import React from 'react';
import { Redirect } from 'react-router-dom';
import { useQuery, Loading, Error, SelectInput, required } from 'react-admin';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Table from '@material-ui/core/Table';

const SelectCategory = () =>{

    let category =  [];

    const { data, loading, error } = useQuery({
        type: 'getList',
        resource: 'activequipcategories',
        payload:  {
            pagination: { page: 1 , perPage: 20 },
            sort: { field: 'name', order: 'ASC' }
        }
    });

    if (loading) return <Loading />;
    if (error) return <Error />;
    if (!data) return null;
    category = data;
    console.log(data)
    return (
        <SelectInput source="category_id"    label="Titles" choices={category} validate={required()} />
        )
}

export default SelectCategory